import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useForm } from 'react-hook-form';
import { Card, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import moment from 'moment';
import MenuHogarSSV from './MenuHogarSSV';

export default function SSVVivienda() {
    const { token } = useAuth();
    const { idEncuesta } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [nombreJefe, setNombreJefe] = useState('');
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const fetchData = async (idEncuesta) => {
        let url = `/encuestassv/hogar/crearformulariovivienda`;
        let obj = { idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;

            resetForm(result.vivienda);
            setNombreJefe(result.jefeHogar.nombre || '');

            console.log('Datos de vivienda obtenidos:', result);
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos de vivienda de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };
    
    useEffect(() => {
        fetchData( idEncuesta);
    }, [idEncuesta]);    

    async function GuardarDatosVivienda() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/hogar/guardardatosvivienda`;
        datosFormulario.vivienda_cuanto_pago_ultima_vez = datosFormulario.vivienda_cuanto_pago_ultima_vez ? moment(datosFormulario.vivienda_cuanto_pago_ultima_vez).format('YYYY-MM-DD') : null;
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de vivienda de la persona.');
            }
        })
        .catch(error => {
            if (error?.response?.data?.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de vivienda de la persona. ' + (error.message || ''));
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }

    const resetForm = (data) => {
        try {
            if (data) {
                if (data.vivienda_cuanto_pago_ultima_vez == '1901-01-01') {
                    data.vivienda_cuanto_pago_ultima_vez = '';
                }
                reset((prevValues) => ({
                    ...prevValues,
                    id: data.id || '',
                    fichaid: data.fichaid || '',
                    vivienda_tipo: data.vivienda_tipo || '',
                    vivienda_material_pred_paredes_exteriores: data.vivienda_material_pred_paredes_exteriores || '',
                    vivienda_material_pred_pisos: data.vivienda_material_pred_pisos || '',
                    vivienda_material_pred_techos: data.vivienda_material_pred_techos || '',
                    vivienda_cual_techo: data.vivienda_cual_techo || '',
                    vivienda_ubica_alto_riesgo: data.vivienda_ubica_alto_riesgo || '',
                    vivienda_afectada_inundacion: data.vivienda_afectada_inundacion || '',
                    vivienda_afectada_avalancha: data.vivienda_afectada_avalancha || '',
                    vivienda_afectada_vientos_fuertes: data.vivienda_afectada_vientos_fuertes || '',
                    vivienda_afectada_derrumbes: data.vivienda_afectada_derrumbes || '',
                    vivienda_afectada_basuras_contaminantes: data.vivienda_afectada_basuras_contaminantes || '',
                    vivienda_afectada_electricidad_gas: data.vivienda_afectada_electricidad_gas || '',
                    vivienda_afectada_ninguna: data.vivienda_afectada_ninguna || '',
                    vivienda_observaciones: data.vivienda_observaciones || '',
                    vivienda_cuantos_cuartos: data.vivienda_cuantos_cuartos || '',
                    vivienda_en_cuantos_cuartos_duermen: data.vivienda_en_cuantos_cuartos_duermen || '',
                    vivienda_cuantas_personas_duermen: data.vivienda_cuantas_personas_duermen || '',
                    vivienda_relacion_propiedad: data.vivienda_relacion_propiedad || '',
                    vivienda_cual_relacion: data.vivienda_cual_relacion || '',
                    vivienda_documento_soporte: data.vivienda_documento_soporte || '',
                    vivienda_servicios_electricidad: data.vivienda_servicios_electricidad || '',
                    vivienda_servicios_alcantarillado: data.vivienda_servicios_alcantarillado || '',
                    vivienda_servicios_acueducto: data.vivienda_servicios_acueducto || '',
                    vivienda_eliminacion_basuras: data.vivienda_eliminacion_basuras || '',
                    vivienda_principal_sanitario: data.vivienda_principal_sanitario || '',
                    vivienda_deuda_ent_financiera: data.vivienda_deuda_ent_financiera || '',
                    vivienda_nombre_entidad: data.vivienda_nombre_entidad || '',
                    vivienda_val_total_deuda: data.vivienda_val_total_deuda || '',
                    vivienda_val_cuota_mes: data.vivienda_val_cuota_mes || '',
                    vivienda_num_cuotas_vencidas: data.vivienda_num_cuotas_vencidas || '',
                    vivienda_cuanto_pago_ultima_vez: data.vivienda_cuanto_pago_ultima_vez ? moment(data.vivienda_cuanto_pago_ultima_vez).format('YYYY-MM-DD') : '',
                    vivienda_plazo_credito: data.vivienda_plazo_credito || '',
                    vivienda_anos_aprobacion_credito: data.vivienda_anos_aprobacion_credito || '',
                }))
            }
        } catch (error) {
            console.error('Error al resetear el formulario:', error);
        }
    }
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Vivienda</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Vivienda</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">                
                <div className="container-fluid">
                    <Form onSubmit={handleSubmit(GuardarDatosVivienda)}>
                        <Card>
                            <Card.Header>
                                <h3 className="box-title"><b>G. VIVIENDA - {getValues("id")}</b></h3>
                                <p>(para el[la] jefe[a] del hogar o su conyugue). - {nombreJefe}</p>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                <Col md={8}>
                                    <FormGroup>
                                    <Form.Label>1. Tipo de vivienda (diligencie por observación) </Form.Label>
                                    <Form.Control as="select" id="vivienda_tipo" style={{width: "100%"}} {...register('vivienda_tipo')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Casa</option>
                                        <option value='2'>2. Apartamento</option>
                                        <option value='3'>3. Cuarto(s) en inquilinato u otro tipo de estructura </option>
                                        <option value='4'>4. Albergue</option>
                                        <option value='5'>5. Otra vivienda (vivienda indigena, carpa, vagón, embarcación, cueva, refugio natural, etc.)</option>
                                    </Form.Control>
                                    <p>Podria describir la vivienda donde reside el hogar?(si la encuesta no se realiza en la vivienda de residencia, se hace ésta pregunta abierta y el encuestador categoriza)</p>
                                    </FormGroup>  
                                </Col>
                                </Row>
                                <Row>  
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>2. ¿Cuál es el material predominante de las paredes exteriores de la vivienda?</Form.Label>
                                    <Form.Control as="select" id="vivienda_material_pred_paredes_exteriores" style={{width: "100%"}} {...register('vivienda_material_pred_paredes_exteriores')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Ladrillo, bloque, material prefabricado, piedra</option>
                                        <option value='2'>2. Madera pulida</option>
                                        <option value='3'>3. Adobe o tapia pisada</option>
                                        <option value='4'>4. Bahareque</option>
                                        <option value='5'>5. Madera burda, tabla, tablón</option>
                                        <option value='6'>6. Guadua</option>
                                        <option value='7'>7. Caña, esterilla, otro tipo de material vegetal</option>
                                        <option value='8'>8. Zinc, tela, cartón, latas, desechos, plástico</option>
                                        <option value='9'>9. Sin paredes</option>
                                    </Form.Control>
                                    </FormGroup>  
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                    <Form.Label>3. ¿Cu&aacute;l es el material predominante de los pisos de la vivienda?</Form.Label>
                                    <Form.Control as="select" id="vivienda_material_pred_pisos" style={{width: "100%"}} {...register('vivienda_material_pred_pisos')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Tierra, arena</option>
                                        <option value='2'>2. Cemento, gravilla</option>
                                        <option value='3'>3. Madera burda, tabla, tablón, otro vegetal</option>
                                        <option value='4'>4. Baldosín, ladrillo, vinisol, otros materiales sintéticos</option>
                                        <option value='5'>5. Mármol</option>
                                        <option value='6'>6. Madera pulida</option>
                                        <option value='7'>7. Alfombra o tapete de pared a pared</option>
                                    </Form.Control>
                                    </FormGroup>  
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                    <Form.Label>4. ¿Cu&aacute;l es el material predominante de los techos de la vivienda?</Form.Label>
                                    <Form.Control as="select" id="vivienda_material_pred_techos" style={{width: "100%"}} {...register('vivienda_material_pred_techos')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Placa de concreto</option>
                                        <option value='2'>2. Teja de barro, zinc, asbesto-cemento CON cielo raso</option>
                                        <option value='3'>3. Teja de barro, zinc, asbesto-cemento SIN cielo raso</option>
                                        <option value='4'>4. Desechos (cartón, latas, sacos, etc.)</option>
                                        <option value='5'>5. Paja o palma</option>
                                        <option value='6'>6. Sin techo</option>
                                        <option value='7'>7. Otro</option>
                                    </Form.Control>
                                    <Form.Control id="vivienda_cual_techo" type="text"  placeholder="Cual?" {...register('vivienda_cual_techo')} />
                                    </FormGroup>  
                                </Col>
                                </Row>
                                <Row>
                                <Col md={6}>
                                    <FormGroup>
                                    <Form.Label>5. ¿Esta vivienda se encuentra ubicada en zona de alto riesgo de desastre natural declarada por alguna autoridad? </Form.Label>
                                    <Form.Control as="select" id="vivienda_ubica_alto_riesgo" style={{width: "100%"}} {...register('vivienda_ubica_alto_riesgo')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                        <option value='9'>98. No sabe/ No informa</option>
                                    </Form.Control>
                                    </FormGroup>  
                                </Col>
                                <Col md={5}>
                                    <FormGroup>
                                    <Form.Label>6. ¿En los ÚLTIMOS 2 AÑOS esta zona se ha visto afectada por: (Seleccion multiple) </Form.Label>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Check type="checkbox" id="vivienda_afectada_inundacion" {...register('vivienda_afectada_inundacion')} />
                                            <span>1. Inundaciones, desbordamientos, crecientes, arroyos</span>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Check type="checkbox" id="vivienda_afectada_avalancha" {...register('vivienda_afectada_avalancha')} />
                                            <span>2. Avalanchas</span>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Check type="checkbox" id="vivienda_afectada_vientos_fuertes" {...register('vivienda_afectada_vientos_fuertes')} />
                                            <span>3. Vientos fuertes</span>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Check type="checkbox" id="vivienda_afectada_derrumbes" {...register('vivienda_afectada_derrumbes')} />
                                            <span>4. Derrumbes o deslizamientos de tierra</span>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Check type="checkbox" id="vivienda_afectada_basuras_contaminantes" {...register('vivienda_afectada_basuras_contaminantes')} />
                                            <span>5. Basura o contaminantes</span>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Check type="checkbox" id="vivienda_afectada_electricidad_gas" {...register('vivienda_afectada_electricidad_gas')} />
                                            <span>6. Zona de riesgo por electricidad o gas</span>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Check type="checkbox" id="vivienda_afectada_ninguna" {...register('vivienda_afectada_ninguna')} />
                                            <span>7. Ninguna</span>
                                        </Col>
                                    </Row>
                                    </FormGroup>  
                                </Col>
                                </Row>
                                <Row>
                                <Col md={12}>
                                    <FormGroup>
                                    <Form.Label>Observaciones</Form.Label>
                                    <Form.Control as="textarea" id="vivienda_observaciones"  rows="3" placeholder="Observaciones" {...register('vivienda_observaciones')}></Form.Control>
                                    </FormGroup>  
                                </Col>
                                </Row>
                                <Row>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>7. Incluyendo sala-comedor, ¿de cuántos cuartos en total dispone este hogar?</Form.Label>
                                    <Form.Control id="vivienda_cuantos_cuartos" type="text"  placeholder="Cuantos" {...register('vivienda_cuantos_cuartos')} />
                                    <p>Nota: Excluya cocinas, baños, garajes y cuartos destinados a negocio.</p>
                                    </FormGroup>  
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>8. ¿En cuántos de esos cuartos duermen las personas de este hogar?</Form.Label>
                                    <Form.Control id="vivienda_en_cuantos_cuartos_duermen" type="text"  placeholder="En cuantos cuartos duermen" {...register('vivienda_en_cuantos_cuartos_duermen')} />
                                    </FormGroup>  
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>9. Regularmente, ¿cuántas personas duermen en esos cuartos?</Form.Label>
                                    <Form.Control id="vivienda_cuantas_personas_duermen" type="text"  placeholder="Cuantas personas duermen" {...register('vivienda_cuantas_personas_duermen')} />
                                    </FormGroup>  
                                </Col>
                                </Row>
                                <Row>
                                <Col md={5}>
                                    <FormGroup>
                                    <Form.Label>10. De acuerdo con las siguientes condiciones de ocupación de la vivienda, su relación con ella es:</Form.Label>
                                    <Form.Control as="select" id="vivienda_relacion_propiedad" style={{width: "100%"}} {...register('vivienda_relacion_propiedad')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Propietario</option>
                                        <option value='2'>2. Poseedor</option>
                                        <option value='3'>3. Arrendatario CON contrato escrito (Pase a pregunta 12)</option>
                                        <option value='4'>4. Arrendatario SIN contrato escrito (Pase a pregunta 12)</option>
                                        <option value='5'>5. Tenedor (Pase a pregunta 12)</option>
                                        <option value='6'>6. Otro, Cual?</option>
                                    </Form.Control>
                                    <Form.Control id="vivienda_cual_relacion" type="text"  placeholder="Cual?" {...register('vivienda_cual_relacion')} />
                                    </FormGroup>     
                                </Col>
                                <Col md={5}>
                                    <FormGroup>
                                    <Form.Label>11. ¿Qué tipo de documento soporte tiene?</Form.Label>
                                    <Form.Control as="select" id="vivienda_documento_soporte" style={{width: "100%"}} {...register('vivienda_documento_soporte')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Escritura, resolución o sentencia registrada</option>
                                        <option value='2'>2. Escritura, resolución o sentencia SIN registrar</option>
                                        <option value='3'>3. Certificado de sana posesión</option>
                                        <option value='4'>4. Contrato de compra venta</option>
                                        <option value='5'>5. Ninguno</option>
                                    </Form.Control>
                                    </FormGroup>   
                                </Col>
                                </Row>
                                <Row>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>12. Con cuáles de los siguientes servicios cuenta el hogar:</Form.Label>
                                    <p>a. Energía eléctrica</p>
                                    <Form.Control as="select" id="vivienda_servicios_electricidad" style={{width: "100%"}} {...register('vivienda_servicios_electricidad')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                    </Form.Control>
                                    <p>b. Alcantarillado</p>
                                    <Form.Control as="select" id="vivienda_servicios_alcantarillado" style={{width: "100%"}} {...register('vivienda_servicios_alcantarillado')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                    </Form.Control>
                                    <p>c. Acueducto</p>
                                    <Form.Control as="select" id="vivienda_servicios_acueducto" style={{width: "100%"}} {...register('vivienda_servicios_acueducto')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No</option>
                                    </Form.Control>
                                    </FormGroup>   
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>13. ¿Cómo eliminan principalmente las basuras en este hogar?</Form.Label>
                                    <Form.Control as="select" id="vivienda_eliminacion_basuras" style={{width: "100%"}} {...register('vivienda_eliminacion_basuras')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Las recogen los servicios de aseo</option>
                                        <option value='2'>2. Las llevan a un contenedor o punto de recolección cercano</option>
                                        <option value='3'>3. Las usan para producir energía, alimentar animales, abono</option>
                                        <option value='4'>4. Las queman</option>
                                        <option value='5'>5. Las entierran</option>
                                        <option value='6'>6. Las arrojan a un basurero público</option>
                                        <option value='7'>7. Las tiran al río, quebrada, patio, lote, zanja, otro sitio</option>
                                        <option value='98'>98. No sabe o no recuerda</option>
                                    </Form.Control>
                                    </FormGroup>  
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>14. ¿Cuál es el principal servicio sanitario con el que cuenta el hogar?</Form.Label>
                                    <Form.Control as="select" id="vivienda_principal_sanitario" style={{width: "100%"}} {...register('vivienda_principal_sanitario')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Inodoro conectado al alcantarillado</option>
                                        <option value='2'>2. Inodoro conectado a pozo séptico</option>
                                        <option value='3'>3. Inodoro sin conexión</option>
                                        <option value='4'>4. Letrina sin conexión</option>
                                        <option value='5'>5. Letrina con salida a un afluente o bajamar</option>
                                        <option value='6'>6. No tiene servicio sanitario</option>
                                    </Form.Control>
                                    </FormGroup>  
                                </Col>
                                </Row>
                                <Row>
                                <Col md={12}>
                                    <Form.Label>Nota:</Form.Label>
                                    <p>A partir de acá, y hasta la pregunta 22, aplica solo para hogares que tienen deudas sobre su vivienda por cierre financiero.</p>
                                </Col>
                                </Row>
                                <Row>
                                <Col md={8}>
                                    <FormGroup>
                                    <Form.Label>15. ¿Tiene usted alguna deuda con alguna entidad financiera  en relación al cierre financiero de su vivienda? </Form.Label>
                                    <Form.Control as="select" id="vivienda_deuda_ent_financiera" style={{width: "100%"}} {...register('vivienda_deuda_ent_financiera')} >
                                        <option value='0'  ></option>
                                        <option value='1'>1. Si</option>
                                        <option value='2'>2. No (Pase a REUNIFICACIÓN FAMILIAR)</option>
                                    </Form.Control>
                                    </FormGroup>      
                                </Col> 
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>16. Entidad financiera con quien tiene la deuda </Form.Label>
                                    <Form.Control id="vivienda_nombre_entidad" type="text"  placeholder="Nombre" {...register('vivienda_nombre_entidad')} />
                                    </FormGroup>
                                </Col>
                                </Row>
                                <Row>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>17. Valor total de la deuda (Descontando lo que ya pagó)</Form.Label>
                                    <Form.Control id="vivienda_val_total_deuda" type="text"  {...register('vivienda_val_total_deuda')} />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>18. Valor de la cuota mensual</Form.Label>
                                    <Form.Control id="vivienda_val_cuota_mes" type="text"  placeholder="Valor" {...register('vivienda_val_cuota_mes')} />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>19. Número de cuotas vencidas (Registrar en MESES)</Form.Label>
                                    <Form.Control id="vivienda_num_cuotas_vencidas" type="text"  placeholder="Cuantas" {...register('vivienda_num_cuotas_vencidas')} />
                                    </FormGroup>
                                </Col>
                                </Row>
                                <Row>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>20. Cuándo pagó la última cuota</Form.Label>
                                    <div className="input-group">
                                        <div className="input-group-addon">
                                        <i className="fa fa-calendar"></i>
                                        </div>
                                        <Form.Control id="vivienda_cuanto_pago_ultima_vez" type="date" data-inputmask="'alias': 'yyyy-mm-dd'" data-mask="" {...register('vivienda_cuanto_pago_ultima_vez')} />
                                    </div>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>21. Cual es el plazo del crédito (Registrar en AÑOS)</Form.Label>
                                    <Form.Control id="vivienda_plazo_credito" type="text"  placeholder="Cuantos" {...register('vivienda_plazo_credito')} />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                    <Form.Label>22. Hace cuántos años le aprobaron el crédito</Form.Label>
                                    <Form.Control id="vivienda_anos_aprobacion_credito" type="text"  placeholder="Cuanto" {...register('vivienda_anos_aprobacion_credito')} />
                                    </FormGroup>
                                </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <Row>
                                    <Col md={12}>
                                        <Button type="submit" className="btn btn-block btn-primary btn-sm" id="btnupdateAlimentos2">Actualizar</Button>  
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </Form>
                    <MenuHogarSSV idEncuesta={idEncuesta} />
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }